import { useState, useRef } from "react";
import {
  AppBar as MuiAppBar,
  Avatar,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Toolbar,
  Button
} from "@mui/material";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { googleLogout } from "@react-oauth/google";

const CustomSimpleAppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

export default function SimpleAppBar(props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  const signOut = () => {
    props.setProfile(null);
    googleLogout();
  };
  const obieLogo = process.env.PUBLIC_URL + "/logo-white.svg";

  return (
    <CustomSimpleAppBar>
      <Toolbar>
        <div style={{ width: 240 }}>
          <img alt="obie-logo" src={obieLogo} style={{ height: 24 }} />
        </div>
        <div style={{ position: "fixed", right: "24px" }}>
          <Button
            variant="filled"
            size="small"
            to="/summary"
            component={Link}
          >
            Summary
          </Button>
          <IconButton ref={anchorRef} onClick={handleToggle}>
            <Avatar alt={props.profile.name} src={props.profile.picture} />
          </IconButton>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open}>
                      <MenuItem onClick={signOut}>Sign out</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Toolbar>
    </CustomSimpleAppBar>
  );
}
